export default {
  bind(el) {
    el.addEventListener("input", (event) => {
      let newValue = event.target.value.toUpperCase();
      if (event.target.value !== newValue) {
        event.target.value = newValue;
        event.target.dispatchEvent(new Event("input", { bubbles: true }));
      }
    });
  }
};